import { render } from "./LeaderboardUserRow.vue?vue&type=template&id=21051e52&scoped=true"
import script from "./LeaderboardUserRow.vue?vue&type=script&lang=js"
export * from "./LeaderboardUserRow.vue?vue&type=script&lang=js"

import "./LeaderboardUserRow.vue?vue&type=style&index=0&id=21051e52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21051e52"]])

export default __exports__